<ra-ui-tree
  #treeComponent
  id="tree-home-folder"
  [tree]="initialTreeModel"
  (treeNodeSelected)="onTreeNodeSelected($event)"
  (treeNodeExpanded)="onTreeNodeExpanded($event)"
>
</ra-ui-tree>
